import { render, staticRenderFns } from "./PreviewPage.vue?vue&type=template&id=67fd4a70&scoped=true&"
import script from "./PreviewPage.vue?vue&type=script&lang=js&"
export * from "./PreviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPage.vue?vue&type=style&index=0&id=67fd4a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd4a70",
  null
  
)

export default component.exports